import { ChatActions, ChatState, CHAT_ACTION_TYPES, ClientUnreadCountItem } from "../../../types/chat"

const initialState: ChatState = {
	message: [],
	channelSid: '',
	outMessage: '',
	usersChannels: [],
	userChatId: '',
	chatNails: [],
	isUploadNewMsgs: false,
	isGetConsumedIndex: false,
	isLastConsumed: {},
	clientUnreadCount: [],
	chatSearch: '',
}

export default (
	state: ChatState = initialState,
	action: ChatActions
): ChatState => {
	switch (action.type) {
		case CHAT_ACTION_TYPES.SET_MESSAGE: {
			return {
				...state,
				message: action.payload,
			}
		}
		case CHAT_ACTION_TYPES.SET_NEW_MESSAGE: {
			return {
				...state,
				message: [...state.message, action.payload],
			}
		}
		case CHAT_ACTION_TYPES.SET_CHENNEL_SID: {
			return {
				...state,
				channelSid: action.payload,
			}
		}
		case CHAT_ACTION_TYPES.SET_OUT_MESSAGE: {
			return {
				...state,
				outMessage: action.payload,
			}
		}
		case CHAT_ACTION_TYPES.SET_USERS_CHANNELS: {
			return {
				...state,
				usersChannels: action.payload,
			}
		}
		case CHAT_ACTION_TYPES.SET_USER_CHAT_ID: {
			return {
				...state,
				userChatId: action.payload,
			}
		}
		case CHAT_ACTION_TYPES.SET_CHAT_NAILS: {
			return {
				...state,
				chatNails: action.payload,
			}
		}
		case CHAT_ACTION_TYPES.SET_CHAT_MORE_MSGS: {
			return {
				...state,
				isUploadNewMsgs: action.payload,
			}
		}
		case CHAT_ACTION_TYPES.SET_CHAT_CONSUMED: {
			return {
				...state,
				isGetConsumedIndex: action.payload,
			}
		}
		case CHAT_ACTION_TYPES.SET_LAST_CONSUMED: {
			return {
				...state,
				isLastConsumed: action.payload,
			}
		}
		case CHAT_ACTION_TYPES.SET_CLIENT_UNREAD_COUNT: {
			const newArray = state.clientUnreadCount.filter((c: ClientUnreadCountItem) =>
				c.sid !== action.payload.sid)
			return {
				...state,
				clientUnreadCount: [...newArray, action.payload],
			}
		}
		case CHAT_ACTION_TYPES.SET_CHAT_SEARCH: {
			return {
				...state,
				chatSearch: action.payload,
			}
		}
		default: {
			return state
		}
	}
}
